import "../styles/landing.scss";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { Context } from "../context/AuthContext";
import { useEffect } from "react";

import logo from "../assets/img/FFF_Logo_Orange_Horizontal.png";
import { Check } from "@mui/icons-material";

// Partner logos (color versions)
import ffipLogo from "../assets/img/landing_img/ffip_color.png";
import guideNetworkLogo from "../assets/img/landing_img/guide_network.png";
import lidrigLogo from "../assets/img/landing_img/lidrig_color.png";
import mainleyLogo from "../assets/img/landing_img/mainely_color.png";
import riverratLogo from "../assets/img/landing_img/riverrat_color.png";

// Landing page images
import appMock from "../assets/img/landing_img/app_mock.png";
import exploreRiversImg from "../assets/img/landing_img/explore_rivers.png";
import checkConditionsImg from "../assets/img/landing_img/check_conditions.png";
import learnTogetherImg from "../assets/img/landing_img/learn_together.png";
import joeDaviesImg from "../assets/img/landing_img/joe_davies.png";
import ellipse2 from "../assets/img/landing_img/ellipse_2.png";
import ellipse4 from "../assets/img/landing_img/ellipse_4.png";
import ellipse5 from "../assets/img/landing_img/ellipse_5.png";

const Landing = () => {
  const navigate = useNavigate();
  const user = useContext(Context);

  useEffect(() => {
    if (!!user?.user) {
      navigate("/select-plan");
    }
  }, [user, navigate]);

  const goToSignup = () => {
    navigate("/login?mode=signup");
  };

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="landing-hero">
        <div className="landing-hero-overlay"></div>
        <div className="landing-hero-content">
          <img className="landing-logo" src={logo} alt="FlyFishFinder Logo" />
          <h1 className="landing-hero-title">
            Find Hidden Fly Fishing<br />Spots Near You
          </h1>
          <p className="landing-hero-subtitle">
            Explore public access, stream conditions, and<br />local intel before you go.
          </p>
          <button className="primary fill hover-shadow landing-cta-btn" onClick={goToSignup}>
            Find My Water
          </button>
          <p className="landing-hero-trial-text">
            14-day free trial &middot; No Charge today &middot; Cancel anytime
          </p>
          <div className="landing-hero-trust">
            <div className="trust-users">
              <div className="trust-avatars">
                <img className="trust-avatar" src={ellipse5} alt="User" />
                <img className="trust-avatar" src={ellipse4} alt="User" />
                <img className="trust-avatar" src={ellipse2} alt="User" />
              </div>
              <span className="trust-label"><b>TRUSTED BY</b></span>
              <span>Over 10K Users</span>
            </div>
            <div className="trust-rating">
              <span className="rating-score">4.8</span>
              <div className="rating-stars-with-label">
                <div className="rating-stars">
                  <span className="star filled">&#9733;</span>
                  <span className="star filled">&#9733;</span>
                  <span className="star filled">&#9733;</span>
                  <span className="star filled">&#9733;</span>
                  <span className="star filled">&#9733;</span>
                </div>
                <span className="rating-label">APP STORE RATING</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partner Logos (color) */}
      <section className="landing-partners">
        <p className="landing-partners-heading">Brands Trusting our Tools</p>
        <div className="landing-partners-inner">
          <img src={mainleyLogo} alt="Mainely Outdoors" />
          <img src={riverratLogo} alt="River Rat" />
          <img src={guideNetworkLogo} alt="The Guide Network" />
          <img src={ffipLogo} alt="FFIP" />
          <img src={lidrigLogo} alt="Lid Rig" />
        </div>
      </section>

      {/* What It Does Section */}
      <section className="landing-features">
        <div className="landing-features-inner">
          <div className="landing-features-text">
            <h2 className="landing-section-title">What It Does</h2>
            <ul className="landing-checklist">
              <li>
                <span className="check-icon"><Check /></span>
                <span>Unlock the largest curated fishing map ever built (220,000+ rivers of intel)</span>
              </li>
              <li>
                <span className="check-icon"><Check /></span>
                <span>Get real access insights — wade spots, easements, and floatable water</span>
              </li>
              <li>
                <span className="check-icon"><Check /></span>
                <span>See real-time flows &amp; conditions for smarter trip timing</span>
              </li>
              <li>
                <span className="check-icon"><Check /></span>
                <span>Build your personal fishing map with saved spots &amp; trip plans</span>
              </li>
            </ul>
          </div>
          <div className="landing-features-image">
            <img src={appMock} alt="FlyFishFinder app showing river details" className="landing-app-mock" />
          </div>
        </div>
      </section>

      {/* Three Feature Cards */}
      <section className="landing-feature-cards">
        <div className="landing-feature-cards-inner">
          <div className="feature-card">
            <h3 className="feature-card-title">Explore Rivers</h3>
            <p className="feature-card-subtitle">MAPS AND FILTERS</p>
            <div className="feature-card-image">
              <img src={exploreRiversImg} alt="Explore rivers with maps and filters" />
            </div>
          </div>
          <div className="feature-card">
            <h3 className="feature-card-title">Check Conditions</h3>
            <p className="feature-card-subtitle">GET FLOWS AND REAL-TIME ALERTS</p>
            <div className="feature-card-image">
              <img src={checkConditionsImg} alt="Check real-time stream conditions" />
            </div>
          </div>
          <div className="feature-card">
            <h3 className="feature-card-title">Learn Together</h3>
            <p className="feature-card-subtitle">CONNECT WITH COMMUNITY AND PROS</p>
            <div className="feature-card-image">
              <img src={learnTogetherImg} alt="Connect with fishing community" />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="landing-testimonial">
        <div className="landing-testimonial-inner">
          <div className="testimonial-image">
            <img className="testimonial-photo" src={joeDaviesImg} alt="Joe Davies - Head Guide" />
          </div>
          <div className="testimonial-content">
            <div className="testimonial-stars">
              <span className="star filled">&#9733;</span>
              <span className="star filled">&#9733;</span>
              <span className="star filled">&#9733;</span>
              <span className="star filled">&#9733;</span>
              <span className="star filled">&#9733;</span>
            </div>
            <p className="testimonial-quote">
              "We used FlyFishFinder maps all day to navigate a new section..absolutely needed that tool. CFS and knowing when I was nearing my take out lead to a perfect trip for my clients."
            </p>
            <p className="testimonial-author">
              <strong>Joe Davies</strong> &nbsp; Head Guide - Milwaukee River Fly Fishing
            </p>
          </div>
        </div>
      </section>

      {/* Trust Badges */}
      <section className="landing-trust-badges">
        <div className="landing-trust-badges-inner">
          <div className="trust-badge">
            <span className="trust-badge-icon"><Check /></span>
            <div>
              <p className="trust-badge-title">14-day free trial</p>
              <p className="trust-badge-sub">Pro Nationwide Plan</p>
            </div>
          </div>
          <div className="trust-badge">
            <span className="trust-badge-icon"><Check /></span>
            <div>
              <p className="trust-badge-title">#1 App Trusted by Pros</p>
              <p className="trust-badge-sub">See Why Guides Choose the App</p>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="landing-bottom-cta">
        <h2>Ready to Find Your Spot?</h2>
        <button className="primary fill hover-shadow landing-cta-btn" onClick={goToSignup}>
          Start Free Trial
        </button>
        <p className="landing-bottom-cta-sub">Cancel anytime. No questions asked.</p>
      </section>
    </div>
  );
};

export default Landing;
